// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "fareType_economy-1z7MW";
var _3 = "active-3d-vc";
var _4 = "fareType_business-GeWJ1";
export { _1 as "__esModule", _2 as "fareType_economy", _3 as "active", _4 as "fareType_business" }
export default { "__esModule": _1, "fareType_economy": _2, "active": _3, "fareType_business": _4 }
